<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="
                  $router.push(
                    '/fertilization/fertilization_application/create'
                  )
                "
              >
                <em class="fa fa-plus"></em>
                {{ $t('fertilization.fertilizer_application_add') }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 text-center">
          <hr />
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              height="530"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="65"
                :resizable="false"
                :align="'center'"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                :min-width="120"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="
                exportToPDF({
                  route: 'fertilization/fertilization_application/pdf',
                  name_file: 'aplicacion_fertilizacion.pdf',
                })
              "
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="
                exportToExcel({
                  route: 'fertilization/fertilization_application/excel',
                  name_file: 'aplicacion_fertilizacion.xlsx',
                })
              "
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-4" v-if="viewDetails">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-12 text-center">
            <h6 class="text-muted">
              {{ $t('fertilization.fertilizer_application_detail') }} -
              {{ fertilizationApplicationForm.date }} -
              <span v-if="fertilizationApplicationForm.farm">{{
                fertilizationApplicationForm.farm.name
              }}</span>
            </h6>
          </div>
        </div>
        <br />
        <div v-if="isIndex()">
          <div class="col-sm-12">
            <el-table
              stripe
              style="width: 100%"
              :data="tableViewData"
              :border="true"
              show-summary
              :summary-method="getSummaries"
            >
              <el-table-column
                min-width="150"
                prop="fertilizer"
                :label="$t('fertilization.fertilizer')"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="number_packages"
                :label="$t('production.bundle_quantity')"
                :formatter="formatterNumberMS"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="number_packages_kg"
                :label="$t('production.bundle_quantity_unit')"
                :formatter="formatterNumberMS"
              ></el-table-column>
              <el-table-column
                :label="$t('samples.nutrient_contribution_unit')"
              >
                <el-table-column
                  :formatter="formatterNumberM"
                  v-for="column in nutrientColumns"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  min-width="75"
                >
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="
                exportToPDF({
                  route:
                    'fertilization/fertilization_application/pdf/' +
                    fertilizationApplicationForm.id,
                  name_file: 'aplicacion_fertilizacion.pdf',
                })
              "
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="
                exportToExcel({
                  route:
                    'fertilization/fertilization_application/excel/' +
                    fertilizationApplicationForm.id,
                  name_file: 'aplicacion_fertilizacion.xlsx',
                })
              "
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import configTable from './fertilizationApplicationTable';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      fertilizationApplicationForm: {},
      pagination: {},
      tableColumns: [],
      tableViewData: null,
      viewDetails: false,
      nutrientColumns: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleView(index, row) {
      this.showHideLoading(true);

      this.tableViewData = [];
      this.fertilizationApplicationForm = Object.assign({}, row);

      if (
        this.fertilizationApplicationForm.fertilization_application_details
          .length > 0
      ) {
        let nutrientsColunm = [];

        this.fertilizationApplicationForm.fertilization_application_details.forEach(
          (element) => {
            let datafer = {};

            datafer.fertilizer = element.fertilizer.name;
            datafer.number_packages = Number(element.number_packages).toFixed(
              1
            );
            datafer.number_packages_kg = Number(
              element.number_packages *
                this.fertilizationApplicationForm.hectares
            ).toFixed(1);

            element.fertilizer.fertilizer_nutrients.forEach(
              (fertilizer_nutrient) => {
                let propname = fertilizer_nutrient.nutrient.symbol.trim();
                propname = propname.toLowerCase();

                let columnsexits = nutrientsColunm.map((colum) => {
                  return colum.prop;
                });

                if (!columnsexits.includes(propname)) {
                  nutrientsColunm.push({
                    label: fertilizer_nutrient.nutrient.symbol,
                    prop: propname,
                  });
                }

                datafer[propname] =
                  (datafer.number_packages_kg *
                    fertilizer_nutrient.percentage) /
                  100;
              }
            );

            this.nutrientColumns = nutrientsColunm;

            this.tableViewData.push(datafer);
          }
        );
      }

      this.viewDetails = true;
      this.showHideLoading();

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);
    },

    handleEdit(index, row) {
      row.url_path_form = '/fertilization/fertilization_application/edit';
      this.fertilizationApplicationForm = Object.assign({}, row);
      sessionStorage.setItem(
        'editForm',
        JSON.stringify(this.fertilizationApplicationForm)
      );
      this.$router.push({
        path: '/fertilization/fertilization_application/edit',
      });
    },

    handleDelete(index, row) {
      this.fertilizationApplicationForm = row;
      SweetAlert.delete(this.fertilizationApplicationForm.date).then(
        (result) => {
          if (result.value) this.deleteFertilizationAplication();
        }
      );
    },

    deleteFertilizationAplication() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.fertilizationApplicationForm.route =
          'fertilization/fertilization_application';
        Axios.destroyMaster(this.fertilizationApplicationForm)
          .then((response) =>
            this.modifyTable(2, this.fertilizationApplicationForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF(data) {
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel(data) {
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      // Assign the Table and Search objects to your data properties
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('fertilization/fertilization_application')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
